import { render, staticRenderFns } from "./ProductBookingPreview.vue?vue&type=template&id=6277f468&scoped=true&"
import script from "./ProductBookingPreview.vue?vue&type=script&lang=ts&"
export * from "./ProductBookingPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6277f468",
  null
  
)

export default component.exports